module.exports = __webpack_public_path__ + "img/fourday_ps_17.b453a99c.jpg";